if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.shoeSizeMobileMedia = this.querySelector('[data-shoe-size-rendered]')
        ? window.matchMedia('(max-width: 767px)')
        : null;
      this.initShoeSizes();
      this.onShoeSizeViewportChange = () => this.shoeSizePickers?.forEach(picker => picker.update());
      this.shoeSizeMobileMedia?.addEventListener('change', this.onShoeSizeViewportChange);
      this.onOptionChange = (event) => {
        this.shoeSizePickers?.forEach(picker => picker.update());
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      };
      this.addEventListener('change', this.onOptionChange);
      this.dispatchEvent(new CustomEvent('product:variant-picker:ready', { bubbles: true }));
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onOptionChange);
      this.shoeSizeMobileMedia?.removeEventListener('change', this.onShoeSizeViewportChange);
    }

    initShoeSizes() {
      this.shoeSizePickers = [];
      const host = this.closest('product-info') || this.parentElement;
      this.querySelectorAll('[data-shoe-size-rendered]').forEach(anchor => {
        const systems = Array.from(anchor.querySelectorAll('[data-shoe-system]'));
        const entries = Array.from(anchor.querySelectorAll('.m-shoe-size-picker__input')).map(field => ({
          field,
          label: field.nextElementSibling
        }));
        const availableSystems = systems.map(button => button.dataset.shoeSystem);
        let system = availableSystems.includes(host.dataset.shoeSizeSystem) ? host.dataset.shoeSizeSystem : availableSystems[0];
        const update = () => {
          systems.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.shoeSystem === system)));
          entries.forEach(({ field, label }) => {
            label.textContent = label.dataset[system];
            if (field.checked) {
              const summary = anchor.querySelector('.option-label--selected');
              if (summary) {
                const summarySystems = this.shoeSizeMobileMedia?.matches
                  ? systems.filter(tab => tab.dataset.shoeSystem === system)
                  : systems;
                summary.textContent = summarySystems.map(tab => `${tab.textContent.trim()} ${label.dataset[tab.dataset.shoeSystem]}`).join(' | ');
              }
            }
          });
        };
        systems.forEach((button, index) => {
          button.onclick = () => {
            system = button.dataset.shoeSystem;
            host.dataset.shoeSizeSystem = system;
            update();
          };
          button.onkeydown = event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % systems.length;
            if (event.key === 'ArrowLeft') next = (index + systems.length - 1) % systems.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = systems.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            systems[next].click();
            systems[next].focus();
          };
        });
        this.shoeSizePickers.push({ entries, update });
        update();
      });
    }

    focusShoeSizeOption(optionId) {
      const entry = this.shoeSizePickers?.flatMap(picker => picker.entries).find(item => item.field.id === optionId);
      if (!entry || entry.field.disabled) return false;
      entry.field.focus({ preventScroll: true });
      return true;
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}
